import React from "react";
import { Flame } from "lucide-react";
import { PlayerName } from "@/components/PlayerCardDialog";

const short = (m) => (m || "").replace(" MATCH", "").replace("REDUCTION GROUP", "GROUP");

export const AlignedChip = ({ r }) => (
  <span className="inline-flex items-center gap-1 whitespace-nowrap rounded border border-lime-700/50 bg-lime-950/40 px-1.5 py-0.5 font-mono text-[10px] text-lime-200"
    title={`Aligned tonight (${r.tonight_match}). Season: scored on ${r.aligned_scoring_nights} of ${r.aligned_nights} aligned nights, ${r.goals} goals`}
    data-testid={`aligned-chip-${r.team}-${r.jersey}`}>
    <Flame className="h-3 w-3 text-lime-400" />
    <span className="text-cyan-400">#{r.jersey}</span>
    <PlayerName name={r.name} team={r.team} className="font-semibold uppercase text-slate-100" />
    <b className="text-lime-300">{r.hit_pct}%</b>
    <span className="text-slate-400">{r.aligned_scoring_nights}/{r.aligned_nights} · {r.goals}G · {short(r.tonight_match)}</span>
  </span>
);

export const AlignedStrip = ({ rows, testKey }) => !rows?.length ? null : (
  <div className="flex flex-wrap items-center gap-1.5 border-t border-slate-800/60 px-4 py-2 pl-11" data-testid={`aligned-alerts-${testKey}`}>
    <span className="font-mono text-[9px] font-bold uppercase tracking-widest text-lime-400">🔢 Aligned scorers</span>
    {rows.map((r) => <AlignedChip key={r.player_id} r={r} />)}
  </div>
);

export default AlignedStrip;
